:host {
  box-sizing: border-box;
  display: block;
  width: 100%;
  z-index: 9900;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}